import { Component, OnInit, Inject } from '@angular/core';
import { NbLogoutComponent, NB_AUTH_OPTIONS, NbAuthService } from '@nebular/auth';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { logout } from 'app/store/meta/meta.actions';
import { PagesState } from 'app/pages/pages-state';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss']
})
export class LogoutComponent extends NbLogoutComponent implements OnInit {
    constructor(
        protected service: NbAuthService,
        private pagesStore: Store<PagesState>,
        @Inject(NB_AUTH_OPTIONS) protected options = {},
        protected router: Router
    ) {
        super(service, options, router);
    }

    ngOnInit() {
        localStorage.removeItem('auth_app_token');
        // TODO: Need to get the location name, we need a proper globale state..

        this.pagesStore.dispatch(logout());

        setTimeout(() => {
            this.router.navigateByUrl('/auth/login');
        }, 1000);
    }
}
